import {lazyComponent} from 'coreUtils/adapters/lazy';

const ShareProductByEmailPopup = lazyComponent(() => import('./ShareProductByEmailPopup'));

export {ShareProductByEmailPopup as default};
